import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

//Actions
import { getSingleMacro } from "../../../actions/insights";

//Charts
import MacroCompoundRadialChart from "../../charts/MacroCompoundRadialChart";
import MacroCompoundVerticalHistogram from "../../charts/MacroCompoundVerticalHistogram";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "../../ui/tabs";

//Components
import Spinner from "../../layout/Spinner";

//MUI
import { Typography, Divider } from "@mui/material";

//Icons
import { ReactComponent as StreakIcon } from "../../../assets/icons/svg/fire-flame.svg";

const SingleMacroModal = ({
  macro,
  date,
  getSingleMacro,
  insights: { singleMacroData, singleMacroDataLoading, singleMacroDataError },
}) => {
  console.log(macro);
  const [activeTab, setActiveTab] = useState("7day");

  const fetchMacroData = async (macroID) => {
    await getSingleMacro(macroID, date.toISOString().split("T")[0]);
  };

  const formatDate = (date) => {
    const day = date.getDate();
    const suffix = ["th", "st", "nd", "rd"][day % 10 > 3 ? 0 : (((day % 100) - (day % 10) !== 10) * day) % 10];
    return date.toLocaleDateString("en-US", { month: "long", day: "numeric" }).replace(/\d+/, day + suffix);
  };

  useEffect(() => {
    fetchMacroData(macro.id);
  }, [macro.id, date]);

  return (
    <div className="flex flex-col gap-4 p-4 h-full">
      {singleMacroDataLoading ? (
        <Spinner />
      ) : singleMacroDataError ? (
        <div>
          <Typography variant="body1">An error occurred while loading your {macro.name} data</Typography>
        </div>
      ) : (
        <div className="flex flex-col">
          <Tabs value={activeTab} onValueChange={setActiveTab} className="w-full">
            <TabsList className="w-full mb-4">
              <TabsTrigger value="7day" className="flex-1">
                7 Day Trend
              </TabsTrigger>
              <TabsTrigger value="today" className="flex-1">
                {formatDate(date)}
              </TabsTrigger>
            </TabsList>

            <TabsContent value="7day">
              <div>
                <div className="w-full flex flex-row items-start justify-between">
                  <div>
                    <Typography variant="h6" className="leading-snug font-normal">
                      {macro.name}
                    </Typography>
                    <Typography variant="subtitle1" className="leading-none font-normal text-secondaryText">
                      Last 7 Days
                    </Typography>
                  </div>

                  <div className="flex flex-row gap-1 items-center">
                    <StreakIcon className="h-5 w-auto fill-complementaryRed" />
                    <Typography variant="subtitle1" className="text-secondaryText-700 leading-none font-medium">
                      <span className="font-medium">{singleMacroData?.streak ? singleMacroData.streak : 0}</span>
                    </Typography>
                  </div>
                </div>
                <div className="py-6">
                  <MacroCompoundVerticalHistogram
                    days={singleMacroData.days}
                    target={singleMacroData.target}
                    date={date}
                    macroName={macro.name}
                    unitName={macro?.unit?.name || ""}
                  />
                </div>
              </div>
            </TabsContent>

            <TabsContent value="today">
              <div>
                <div className="w-full flex flex-row items-start justify-between">
                  <div>
                    <Typography variant="h6" className="leading-snug font-normal">
                      {macro.name}
                    </Typography>
                    <Typography variant="subtitle1" className="leading-none font-normal text-secondaryText">
                      {formatDate(date)}
                    </Typography>
                  </div>

                  <div className="flex flex-row gap-1 items-center">
                    <StreakIcon className="h-5 w-auto fill-complementaryRed" />
                    <Typography variant="subtitle1" className="text-secondaryText-700 leading-none font-medium">
                      <span className="font-medium">{singleMacroData?.streak ? singleMacroData.streak : 0}</span>
                    </Typography>
                  </div>
                </div>
                <div className="my-6 min-h-[350px] flex flex-col items-center justify-center w-full">
                  <div className="w-full">
                    <MacroCompoundRadialChart macroData={singleMacroData} showMacroName={false} animate={false} />
                  </div>
                </div>
              </div>
            </TabsContent>
          </Tabs>

          {false && (
            <div className="flex flex-col mt-4">
              <Typography variant="h6" className="leading-snug font-normal">
                {`${macro.name} Events`}
              </Typography>
              <Typography variant="subtitle1" className="leading-none font-normal text-secondaryText">
                {formatDate(date)}
              </Typography>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

SingleMacroModal.propTypes = {
  macro: PropTypes.object.isRequired,
  date: PropTypes.string.isRequired,
  getSingleMacro: PropTypes.func.isRequired,
  insights: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  insights: state.insights,
});

export default connect(mapStateToProps, { getSingleMacro })(SingleMacroModal);
